import React from 'react'
import PropTypes from 'prop-types'
import { Container, Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import DashboardCard from '../../DashboardCard'

const ReviewStatsSummary = (props) => {
  const { data, title } = props

  if (!data || !data.sla_analytics || !data.review_stats || !data.review_stats.finished) {
    return <div>Loading...</div>
  }

  const renderStatBlock = (label, value) => (
    <Grid container spacing={2} sx={{ paddingLeft: '2rem' }}>
      <Grid item md='auto' sm={12}>
        <Typography variant='body1' sx={{ fontWeight: 'bold', fontSize: '16' }}>
          {label}:
        </Typography>
      </Grid>
      <Grid item md='auto' sm={12}>
        <Typography variant='body1' sx={{ fontSize: '16' }}>
          {value}
        </Typography>
      </Grid>
    </Grid>
  )

  const {
    min_analysis_time,
    average_analysis_time,
    max_analysis_time,
  } = data.sla_analytics

  const {
    created,
    suspended,
    forwarded,
    pending,
  } = data.review_stats

  const { approved, reproved } = data.review_stats?.finished

  const hoursFromSeconds = (seconds) => (Number.parseInt(seconds, 10) / 3600).toFixed(2)

  return (
    <DashboardCard title={title} sx={{ height: '100%' }}>
      <Container maxWidth='xl' sx={{ width: '100%', margin: '0 auto', padding: '1rem' }}>
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} sx={{ marginBottom: '1rem' }}>
            <h4>Tempos de duração das análises</h4>
          </Grid>

          {renderStatBlock('Tempo mínimo', `${hoursFromSeconds(min_analysis_time)} horas`)}
          {renderStatBlock('Tempo médio', `${hoursFromSeconds(average_analysis_time)} horas`)}
          {renderStatBlock('Tempo máximo', `${hoursFromSeconds(max_analysis_time)} horas`)}

          <Grid item md={12} sm={12} sx={{ marginBottom: '1rem' }}>
            <h4>Análises por status</h4>
          </Grid>
          {renderStatBlock('Criadas', created)}
          {renderStatBlock('Suspensas', suspended)}
          {renderStatBlock('Finalizadas', data.review_stats.finished.total)}
          {renderStatBlock('Encaminhadas', forwarded)}
          {renderStatBlock('Em andamento', pending)}

          <Grid item md={12} sm={12} sx={{ marginBottom: '1rem' }}>
            <h4>Análises finalizadas</h4>
          </Grid>
          {renderStatBlock('Análises aprovadas', approved)}
          {renderStatBlock('Análises reprovadas', reproved)}
        </Grid>
      </Container>
    </DashboardCard>
  )
}

ReviewStatsSummary.propTypes = {
  data: PropTypes.shape({
    sla_analytics: PropTypes.shape({
      average_analysis_time: PropTypes.number.isRequired,
      min_analysis_time: PropTypes.number.isRequired,
      max_analysis_time: PropTypes.number.isRequired,
    }),
    review_stats: PropTypes.shape({
      created: PropTypes.number.isRequired,
      suspended: PropTypes.number.isRequired,
      forwarded: PropTypes.number.isRequired,
      pending: PropTypes.number.isRequired,
      finished: PropTypes.shape({
        total: PropTypes.number.isRequired,
        approved: PropTypes.number.isRequired,
        reproved: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    application_stats: PropTypes.shape({
      approved: PropTypes.shape({
        total: PropTypes.number.isRequired,
        manual: PropTypes.number.isRequired,
        auto: PropTypes.number.isRequired,
      }).isRequired,
      reproved: PropTypes.shape({
        total: PropTypes.number.isRequired,
        manual: PropTypes.number.isRequired,
        auto: PropTypes.number.isRequired,
      }).isRequired,
      finished: PropTypes.number.isRequired,
      expired: PropTypes.number.isRequired,
      waiting_review: PropTypes.number.isRequired,
      dd_in_progress: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
}

export default ReviewStatsSummary
